import type { UrgencyLevel } from "../hooks/usePhaseCountdown";

/** Compact countdown chip for phase headers. */
export function PhaseTimer({
  label,
  urgency,
  active,
  className = "",
}: {
  label: string;
  urgency: UrgencyLevel;
  active: boolean;
  className?: string;
}) {
  if (!active) return null;

  const tone =
    urgency === "critical"
      ? "border-[rgba(232,93,93,0.45)] bg-[rgba(232,93,93,0.18)] text-[#ffb4b4]"
      : urgency === "warn"
        ? "border-[rgba(230,184,77,0.4)] bg-[rgba(230,184,77,0.14)] text-[#f0d48a]"
        : "border-white/12 bg-black/30 text-[var(--color-cream)]";

  const pulse = urgency === "critical" ? "animate-pulse" : "";

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 font-mono text-sm font-semibold tracking-wide tabular-nums ${tone} ${pulse} ${className}`}
      title="Time left this phase — auto-submits at 0:00"
      role="timer"
      aria-live="polite"
    >
      <span className="text-[10px] font-semibold tracking-[0.14em] uppercase opacity-70">
        Time
      </span>
      <span>{label}</span>
    </div>
  );
}
